import { _data, _on, _qs, _qsa } from '../../../js/shortJS'
import triggers from '../store/triggers'
import { state } from '../store/state'
import elements from '../store/elements'
import setSizeToImgSrc from '../helpers/setSizeToImgSrc'

const doc = document

const sizes = [180, 360, 540, 720, 900, 1080, 1200]
const getSrcSet = (link) => sizes.map(size => `${setSizeToImgSrc(link, size)} ${size}w`).join(',')

const mobileViewBreakpoint = 1200

const thumbnails = [...doc[_qsa]('.thumbnail-image-horizontal > .thumbnail-image-horizontal-item')]
const fancyboxImages = [...doc[_qsa]('.fancybox')]
const currentThumbnails = thumbnails.length > 5 ? [] : thumbnails

for (const elem of thumbnails) {
  elem[_on]('click', () => {
    const newNumb = currentThumbnails.indexOf(elem)
    if (state.imgIndex !== newNumb) {
      state.imgIndex = newNumb
      triggers.emitEvent('state:imgIndex', [newNumb])
    }
  })
}

elements.image.onload = () => {
  triggers.emitEvent('mainImage:loaded')
}

const selectImage = (imgIndex) => {
  const thumbnail = currentThumbnails[imgIndex]

  if (!thumbnail) return

  thumbnail[_qs]('input').checked = true

  fancyboxImages[0].style.pointerEvents = ''
  for (const e of fancyboxImages[0][_qsa]('.manifying_glass_icon_container, .product__artwork-button')) { e.hidden = false }
  elements.image.src = thumbnail[_data].image
  elements.image.srcset = getSrcSet(thumbnail[_data].image)
  elements.image.hidden = false

  if (fancyboxImages.length > 1) {
    for (const fancy of fancyboxImages) {
      if (+fancy[_data].imageNumber !== imgIndex) continue
      fancy.href = fancyboxImages[0].href.split()
      fancy[_data].imageNumber = fancyboxImages[0][_data].imageNumber
      break
    }
  }
  fancyboxImages[0].href = thumbnail[_data].image
  fancyboxImages[0][_data].imageNumber = imgIndex
}

const arrowLeft = doc[_qs]('.product__image-arrow--left')
const arrowRight = doc[_qs]('.product__image-arrow--right')

if (arrowLeft && arrowRight) {
  arrowLeft[_on]('click', () => {
    if (state.imgIndex !== 0) {
      state.imgIndex--
    } else {
      state.imgIndex = currentThumbnails.length - 1
    }
    triggers.emitEvent('state:imgIndex', [state.imgIndex])
  })

  arrowRight[_on]('click', () => {
    if (state.imgIndex < currentThumbnails.length - 1) {
      state.imgIndex++
    } else {
      state.imgIndex = 0
    }
    triggers.emitEvent('state:imgIndex', [state.imgIndex])
  })
}

const imagesStandard = () => {
  selectImage(state.imgIndex)
  triggers.on('state:imgIndex', selectImage)

  if (window.matchMedia(`(max-width: ${mobileViewBreakpoint}px)`).matches) {
    const interval = setInterval(() => {
      if (!window.Flickity) return
      const flkty = window.Flickity.data('.product-single__photo')
      if (flkty) {
        clearInterval(interval)

        const updateFlickity = () => {
          flkty.select(0)
        }
        updateFlickity()
        triggers.on('state:layout', updateFlickity)

        window.onload = () => {
          flkty.resize()
        }
      }
    }, 100)
  }
}

export default imagesStandard
